module.exports = __webpack_public_path__ + "static/media/Shaq.bb903955.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Shaq.jpg
// module id = 414
// module chunks = 0